import { Box, Grid, InputLabel } from '@mui/material';

export const FilterPanel = ({ filters = [], columns = 3 }) => (
  <Grid item sx={{ width: '100%' }}>
    <Box
      display="grid"
      gridTemplateColumns={`repeat(${columns}, 1fr)`}
      justifyContent="space-between"
      alignItems="stretch"
      gap="24px"
    >
      {filters.map(({ key, label, renderComponent, value, onChange }) => (
        <Box key={key}>
          {label && (
            <InputLabel
              id={`filter-label-${key}`}
              variant="caption"
              sx={{ mb: 0.5, display: 'block' }}
            >
              {label}
            </InputLabel>
          )}
          {renderComponent({ value, onChange, sx: { height: '48px' } })}
        </Box>
      ))}
    </Box>
  </Grid>
);
